module.exports = __webpack_public_path__ + "img/Stones1.8feb9190.jpg";